'use strict'

import './elements/dropdown'
import './elements/select'

console.log('ok')
